import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './inspection-item.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionItemDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const inspectionItemEntity = useAppSelector(state => state.inspectionItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="inspectionItemDetailsHeading">
          <Translate contentKey="fleetSenseApp.inspectionItem.detail.title">InspectionItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{inspectionItemEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.inspectionItem.name">Name</Translate>
            </span>
          </dt>
          <dd>{inspectionItemEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.inspectionItem.description">Description</Translate>
            </span>
          </dt>
          <dd>{inspectionItemEntity.description}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.inspectionItem.company">Company</Translate>
          </dt>
          <dd>{inspectionItemEntity.company ? inspectionItemEntity.company.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/inspection-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/inspection-item/${inspectionItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InspectionItemDetail;
